import React, { Component } from 'react';
import SimpleLayout from './SimpleLayout';
import PublicEventAddParent from '../components/pubevent/PublicEventAddParent';
import '../css/style.css';
import '../components/Home.css';

class PublicEventAddLayout extends Component {

    render(){
        return (
            <SimpleLayout>
                <PublicEventAddParent />
            </SimpleLayout>              
        );
    }

}

export default PublicEventAddLayout;